"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var shortcutHelpers_1 = require("../shortcutHelpers");
var FWD_SLASH = '/';
function useShortcutPanel() {
    var _a = react_1.default.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    function handleToggleSidePanel() {
        setIsOpen(function (prevIsOpen) { return !prevIsOpen; });
    }
    var handleKeyDown = react_1.default.useCallback(function (keyboardEvent) {
        var CTRL_FWD_SLASH = !shortcutHelpers_1.isMac && keyboardEvent.ctrlKey && keyboardEvent.key === FWD_SLASH;
        var META_FWD_SLASH = shortcutHelpers_1.isMac && keyboardEvent.metaKey && keyboardEvent.key === FWD_SLASH;
        if (CTRL_FWD_SLASH || META_FWD_SLASH) {
            var isModalVisible = document.querySelector('[role=dialog][aria-modal]:not([aria-hidden]):not([data-sri-anchor="keyboard-shortcut-panel"])');
            if (isModalVisible === null) {
                handleToggleSidePanel();
            }
        }
    }, []);
    react_1.default.useLayoutEffect(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
    return [isOpen, handleToggleSidePanel];
}
exports.default = useShortcutPanel;
//# sourceMappingURL=useShortcutPanel.js.map